export const ChannelCycle = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.72725 14.2222C8.8182 15.1111 7.9091 16 6.0909 16C4.27272 16 2 14.6667 2 12C2 9.33335 4.27272 8 6.0909 8C8.8182 8 10.1818 9.7778 12 12C13.8182 14.2222 15.1818 16 17.9091 16C19.7272 16 22 14.6667 22 12C22 9.33335 19.7272 8 17.9091 8C16.0909 8 14.7272 9.33335 14.2727 9.7778"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
    />
  </svg>
);
